// Production opens the released Broker Loop app; every other build mode opens Broker Loop Dev.
const getBrokerLoopProtocol = (mode: string = import.meta.env.MODE) =>
  mode === "production" ? "brokerloop" : "brokerloop-dev";

const buildBrokerLoopDeepLink = (params: URLSearchParams, mode?: string) =>
  `${getBrokerLoopProtocol(mode)}://?${params.toString()}`;

export { getBrokerLoopProtocol, buildBrokerLoopDeepLink };
